import { RefCallback, useCallback, useRef, useState } from "react";

export const useScrollFades = () => {
  const dropdownRef = useRef<HTMLUListElement | null>(null);

  const [hasFadeTop, setHasFadeTop] = useState(false);
  const [hasFadeBottom, setHasFadeBottom] = useState(false);

  const handleScroll = useCallback(() => {
    if (dropdownRef.current) {
      const { scrollHeight, clientHeight, scrollTop } = dropdownRef.current;

      if (scrollHeight > clientHeight) {
        setHasFadeTop(Boolean(scrollTop));
        setHasFadeBottom(scrollHeight > clientHeight + scrollTop);
      }
    }
  }, []);

  const dropdownCallbackRef: RefCallback<HTMLUListElement> = useCallback(
    (node) => {
      if (!node) {
        return;
      }

      dropdownRef.current = node;
      handleScroll();
    },
    [handleScroll]
  );

  return {
    dropdownRef,
    dropdownCallbackRef,
    hasFadeTop,
    hasFadeBottom,
    handleScroll,
  };
};
